import { useState, useEffect } from "react";
import { toast } from "sonner";
import { BellRing, BellOff, Loader2 } from "lucide-react";
import {
  pushSupported,
  getSubscriptionState,
  subscribePush,
  unsubscribePush,
  sendTestPush,
} from "@/lib/push";

const NotificheButton = () => {
  const [state, setState] = useState("loading");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!pushSupported()) {
      setState("unsupported");
      return;
    }
    getSubscriptionState().then(setState).catch(() => setState("default"));
  }, []);

  const attiva = async () => {
    setBusy(true);
    try {
      await subscribePush();
      setState("subscribed");
      toast.success("Notifiche attivate! Riceverai i promemoria anche con app chiusa.");
      await sendTestPush();
    } catch (e) {
      if (e.message === "denied") {
        toast.error("Permesso negato. Abilita le notifiche dalle impostazioni del browser.");
        setState("denied");
      } else {
        toast.error("Impossibile attivare le notifiche su questo dispositivo.");
      }
    } finally {
      setBusy(false);
    }
  };

  const disattiva = async () => {
    setBusy(true);
    try {
      await unsubscribePush();
      setState("default");
      toast.info("Notifiche disattivate.");
    } catch {
      toast.error("Errore durante la disattivazione.");
    } finally {
      setBusy(false);
    }
  };

  if (state === "unsupported" || state === "loading") return null;

  if (state === "subscribed") {
    return (
      <button
        onClick={disattiva}
        disabled={busy}
        data-testid="btn-disattiva-notifiche"
        className="flex items-center gap-2 px-3 py-2 rounded-lg border border-[#E5E2DC] bg-white text-[#5C5F58] text-sm font-medium hover:bg-[#F2F0EB] transition-colors"
      >
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <BellOff className="w-4 h-4" strokeWidth={1.8} />}
        <span className="hidden sm:inline">Notifiche attive</span>
      </button>
    );
  }

  return (
    <button
      onClick={attiva}
      disabled={busy || state === "denied"}
      data-testid="btn-attiva-notifiche"
      className="flex items-center gap-2 px-3 py-2 rounded-lg bg-[#1C3F35] text-white text-sm font-medium hover:bg-[#132A23] transition-colors hover:-translate-y-0.5 disabled:opacity-50"
    >
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <BellRing className="w-4 h-4" strokeWidth={1.8} />}
      <span className="hidden sm:inline">{state === "denied" ? "Notifiche bloccate" : "Attiva notifiche"}</span>
    </button>
  );
};

export default NotificheButton;
